import PropTypes from 'prop-types'
import React, { Component } from 'react'
import styles from './layout-plain.styl'

export default class LayoutPlain extends Component {
  static propTypes = {
    children: PropTypes.any,
    body: PropTypes.array,
    divider: PropTypes.bool,
    header: PropTypes.object,
    footer: PropTypes.object,
    banner: PropTypes.object,
    announcement: PropTypes.object,
    description: PropTypes.string,
    colWidth: PropTypes.string,
    greyBg: PropTypes.bool
  }
  static defaultProps = {
    colWidth: 'auto',
    divider: false
  }

  render() {
    const {
      children,
      body,
      header,
      footer,
      colWidth,
      divider,
      greyBg,
      banner,
      announcement,
      description
    } = this.props

    return (
      <div
        className={`${styles.module} ${divider ? styles.divider : ''} ${greyBg ? styles.greyTheme : ''}`}
      >
        {header &&
          <div className={styles.header}>
            {header}
          </div>}

        {banner &&
          <div className={`container ${styles.compact}`}>
            <div className={styles.banner}>
              {banner}
            </div>
          </div>}

        {description && <div className={`container ${styles.container}`}>
          <div className={styles.description}>
          <p>{description}</p>
          </div>
        </div>}

        {announcement}

        {body &&
          <div className={styles.body}>
            <div className={`container ${styles.container}`}>
              <div className={styles.row}>
                {body.map((item, index) => (
                  <div key={index} className={styles.col}>
                    <div style={{ width: colWidth, maxWidth: '100%' }}>
                      {item}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>}

        {children &&
          <div
            className={`container ${styles.container} ${greyBg ? styles.bordered : ''}`}
          >
            {children}
          </div>}

        {footer &&
          <div className={styles.footer}>
            {footer}
          </div>}
      </div>
    )
  }
}
